import { render, staticRenderFns } from "./Otomotif.vue?vue&type=template&id=2783ab5a&scoped=true&"
import script from "./Otomotif.vue?vue&type=script&lang=js&"
export * from "./Otomotif.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2783ab5a",
  null
  
)

export default component.exports